import { useEffect, useRef } from 'react';

/**
 * Hook for auto-expanding textarea height based on content
 * @param {string} value - The current value of the textarea
 * @param {number} minHeight - Minimum height in pixels (default: 21)
 * @param {number} maxHeight - Maximum height in pixels (optional)
 * @returns {Object} - Ref to attach to textarea element
 */
const useAutoExpandTextarea = (value, minHeight = 21, maxHeight = null) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      // Reset height to auto to get the correct scrollHeight
      textarea.style.height = 'auto';
      
      // Calculate the new height
      const scrollHeight = textarea.scrollHeight;
      let newHeight = Math.max(scrollHeight, minHeight);
      
      // Apply max height limit if specified
      if (maxHeight && newHeight > maxHeight) {
        newHeight = maxHeight;
        textarea.style.overflowY = 'auto';
      } else {
        textarea.style.overflowY = 'hidden';
      }
      
      // Set the new height
      textarea.style.height = `${newHeight}px`;
    }
  }, [value, minHeight, maxHeight]);

  return textareaRef;
};

export default useAutoExpandTextarea;
